import { getFoojiDomain } from "./provider";

export default {
  frontendBaseUrl: `https://${import.meta.env.FOOJI_FRONTEND_SUBDOMAIN as string}.${getFoojiDomain()}`,
  authApiBaseUrl: `https://${import.meta.env.FOOJI_AUTH_API_SUBDOMAIN as string}.${getFoojiDomain()}`,
  wsBaseUrl: `https://${import.meta.env.FOOJI_WS_SUBDOMAIN as string}.${getFoojiDomain()}`,
  listenerBaseUrl: `https://${import.meta.env.FOOJI_LISTENER_SUBDOMAIN as string}.${getFoojiDomain()}`,
  serverlessFunctionsBaseUrl:
    `https://${import.meta.env.FOOJI_SERVERLESS_FUNCTIONS_SUBDOMAIN as string}.${getFoojiDomain()}`
};
